import type { Image, ToolMark } from './schema'
import { certification, externalLinks, socials } from './site'
import { tools } from './tools'

/**
 * The Home About section (pick D "The floor" on PLAN-about.html, 2026-10-02). Copy is v1's
 * AboutGrid.tsx word for word, as judged on the canvas; only the product name follows this site's
 * spelling (Kape.Tools).
 */
export const aboutSection = {
  eyebrow: 'About',
  titleThin: "Hi, I'm",
  titleBold: 'Kenneth.',
  lede: 'I build the systems that run a business when nobody is watching them.',
  lead: 'I spent eleven years finding out exactly where work breaks.',
  leadQuiet: 'Now I build the machines that replace the remembering.',
  note: {
    company: 'BrewedOps is my company',
    product: { label: 'Kape.Tools', href: externalLinks.kapeTools },
    rest: 'sits under it - the workspace I built for Filipino freelancers and VAs because I needed it before anyone else did. Everything I sell, I run myself first.',
  },
  picture: {
    src: '/images/profile/desk.webp',
    srcSet: '/images/profile/800/desk.webp 800w, /images/profile/desk.webp 1200w',
    alt: 'Illustration of Kenneth Villar at a desk, working at a monitor with a coffee beside him',
    width: 1200,
    height: 889,
  } satisfies Image,
}

export const capabilities: { title: string; tools: ToolMark[] }[] = [
  { title: 'GHL System Architect & AI Automations', tools: [tools.ghl, tools.n8n, tools.zapier] },
  { title: 'Aspiring AI Engineer', tools: [tools.claude, tools.codex, tools.glm, tools.qwen, tools.hermes] },
  { title: 'AI Web Dev', tools: [tools.claude, tools.codex, tools.namecheap, tools.cloudflare, tools.github] },
  { title: 'Tech VA / Ops Manager', tools: [tools.workspace, tools.slack, tools.fireflies] },
]

export type AboutCredential = {
  id: 'cert' | 'place' | 'hla' | 'diskarte'
  title: string
  detail: string
  image?: Image
  /** A dark-theme version of the mark, when the light one would vanish on Onyx (or the reverse). */
  imageDark?: Image
  href?: string
}

export const credentials: AboutCredential[] = [
  { id: 'cert', title: certification.title, detail: certification.detail, image: { ...certification.image!, alt: '' } },
  { id: 'place', title: 'Based in the Philippines', detail: 'GMT+8 · US hours' },
  {
    id: 'hla',
    title: 'HL Accelerator',
    detail: 'Community moderator',
    href: 'https://hlaccelerator.com',
    image: { src: '/images/badges/64/hl-accelerator.webp', alt: '', width: 64, height: 64 },
  },
  // Kenneth, 2026-10-03: "Add Diskarte Digital beside HL Accelerator ... My role is Admin".
  {
    id: 'diskarte',
    title: 'Diskarte Digital',
    detail: 'Admin',
    href: socials.find((s) => s.icon === 'diskarte')!.href,
    image: { src: '/images/badges/64/diskarte-digital-light.webp', alt: '', width: 64, height: 64 },
    imageDark: { src: '/images/badges/64/diskarte-digital.webp', alt: '', width: 64, height: 64 },
  },
]
